// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen.js';
import { allNounQuery, companyActionBulkSave, companyActionSave, companyGet, companyGetChangeLog, companyInsert, companyQuery, companySave, compSetActionDownload, compSetActionRateQuery, compSetDelete, compSetGet, compSetGetHistory, compSetPatch, compSetPut, compSetQuery, contentDownload, hotelActionBulkSave, hotelActionExcelRateChart, hotelActionGsheetsRateChart, hotelActionSave, hotelActionStatuses, hotelGet, hotelGetChangeLog, hotelInsert, hotelQuery, hotelSave, locationActionBulkSave, locationActionSave, locationGet, locationGetChangeLog, locationInsert, locationQuery, locationSave, type Options, organizationActionAllowedScopes, organizationActionGsheetsFolder, organizationActionUploadLogo, organizationGet, organizationSave, organizationUserGet, organizationUserPatch, organizationUserPut, organizationUserQuery, rateHistoryQueryRates, rateLatestQueryLatest, rateStayQuery, userActionLeaveOrganization, userGetCurrentUser, userGetOrganizations, userInvitationDelete, userInvitationInsert, userInvitationQuery, userSaveCurrentUser } from '../sdk.gen.js';
import type { AllNounQueryData, AllNounQueryError, AllNounQueryResponse, CompanyActionBulkSaveData, CompanyActionBulkSaveError, CompanyActionBulkSaveResponse, CompanyActionSaveData, CompanyActionSaveError, CompanyActionSaveResponse, CompanyGetChangeLogData, CompanyGetChangeLogError, CompanyGetChangeLogResponse, CompanyGetData, CompanyGetError, CompanyGetResponse, CompanyInsertData, CompanyInsertError, CompanyInsertResponse, CompanyQueryData, CompanyQueryError, CompanyQueryResponse, CompanySaveData, CompanySaveError, CompanySaveResponse, CompSetActionDownloadData, CompSetActionDownloadError, CompSetActionDownloadResponse, CompSetActionRateQueryData, CompSetActionRateQueryError, CompSetActionRateQueryResponse, CompSetDeleteData, CompSetDeleteError, CompSetDeleteResponse, CompSetGetData, CompSetGetError, CompSetGetHistoryData, CompSetGetHistoryError, CompSetGetHistoryResponse, CompSetGetResponse, CompSetPatchData, CompSetPatchError, CompSetPatchResponse, CompSetPutData, CompSetPutError, CompSetPutResponse, CompSetQueryData, CompSetQueryError, CompSetQueryResponse, ContentDownloadData, ContentDownloadError, ContentDownloadResponse, HotelActionBulkSaveData, HotelActionBulkSaveError, HotelActionBulkSaveResponse, HotelActionExcelRateChartData, HotelActionExcelRateChartError, HotelActionExcelRateChartResponse, HotelActionGsheetsRateChartData, HotelActionGsheetsRateChartError, HotelActionGsheetsRateChartResponse, HotelActionSaveData, HotelActionSaveError, HotelActionSaveResponse, HotelActionStatusesData, HotelActionStatusesError, HotelActionStatusesResponse, HotelGetChangeLogData, HotelGetChangeLogError, HotelGetChangeLogResponse, HotelGetData, HotelGetError, HotelGetResponse, HotelInsertData, HotelInsertError, HotelInsertResponse, HotelQueryData, HotelQueryError, HotelQueryResponse, HotelSaveData, HotelSaveError, HotelSaveResponse, LocationActionBulkSaveData, LocationActionBulkSaveError, LocationActionBulkSaveResponse, LocationActionSaveData, LocationActionSaveError, LocationActionSaveResponse, LocationGetChangeLogData, LocationGetChangeLogError, LocationGetChangeLogResponse, LocationGetData, LocationGetError, LocationGetResponse, LocationInsertData, LocationInsertError, LocationInsertResponse, LocationQueryData, LocationQueryError, LocationQueryResponse, LocationSaveData, LocationSaveError, LocationSaveResponse, OrganizationActionAllowedScopesData, OrganizationActionAllowedScopesError, OrganizationActionAllowedScopesResponse, OrganizationActionGsheetsFolderData, OrganizationActionGsheetsFolderError, OrganizationActionGsheetsFolderResponse, OrganizationActionUploadLogoData, OrganizationActionUploadLogoError, OrganizationActionUploadLogoResponse, OrganizationGetData, OrganizationGetError, OrganizationGetResponse, OrganizationSaveData, OrganizationSaveError, OrganizationSaveResponse, OrganizationUserGetData, OrganizationUserGetError, OrganizationUserGetResponse, OrganizationUserPatchData, OrganizationUserPatchError, OrganizationUserPatchResponse, OrganizationUserPutData, OrganizationUserPutError, OrganizationUserPutResponse, OrganizationUserQueryData, OrganizationUserQueryError, OrganizationUserQueryResponse, RateHistoryQueryRatesData, RateHistoryQueryRatesError, RateHistoryQueryRatesResponse, RateLatestQueryLatestData, RateLatestQueryLatestError, RateLatestQueryLatestResponse, RateStayQueryData, RateStayQueryError, RateStayQueryResponse, UserActionLeaveOrganizationData, UserActionLeaveOrganizationError, UserActionLeaveOrganizationResponse, UserGetCurrentUserData, UserGetCurrentUserError, UserGetCurrentUserResponse, UserGetOrganizationsData, UserGetOrganizationsError, UserGetOrganizationsResponse, UserInvitationDeleteData, UserInvitationDeleteError, UserInvitationDeleteResponse, UserInvitationInsertData, UserInvitationInsertError, UserInvitationInsertResponse, UserInvitationQueryData, UserInvitationQueryError, UserInvitationQueryResponse, UserSaveCurrentUserData, UserSaveCurrentUserError, UserSaveCurrentUserResponse } from '../types.gen.js';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const allNounQueryQueryKey = (options?: Options<AllNounQueryData>) => createQueryKey('allNounQuery', options);

/**
 * Query all-noun rows by name text search
 */
export const allNounQueryOptions = (options?: Options<AllNounQueryData>) => queryOptions<AllNounQueryResponse, AllNounQueryError, AllNounQueryResponse, ReturnType<typeof allNounQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await allNounQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: allNounQueryQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const allNounQueryInfiniteQueryKey = (options?: Options<AllNounQueryData>): QueryKey<Options<AllNounQueryData>> => createQueryKey('allNounQuery', options, true);

/**
 * Query all-noun rows by name text search
 */
export const allNounQueryInfiniteOptions = (options?: Options<AllNounQueryData>) => {
    const opts = infiniteQueryOptions<AllNounQueryResponse, AllNounQueryError, InfiniteData<AllNounQueryResponse>, QueryKey<Options<AllNounQueryData>>, number | Pick<QueryKey<Options<AllNounQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AllNounQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await allNounQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: allNounQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const compSetQueryQueryKey = (options?: Options<CompSetQueryData>) => createQueryKey('compSetQuery', options);

/**
 * Query multiple relationships.
 */
export const compSetQueryOptions = (options?: Options<CompSetQueryData>) => queryOptions<CompSetQueryResponse, CompSetQueryError, CompSetQueryResponse, ReturnType<typeof compSetQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await compSetQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: compSetQueryQueryKey(options)
});

export const compSetQueryInfiniteQueryKey = (options?: Options<CompSetQueryData>): QueryKey<Options<CompSetQueryData>> => createQueryKey('compSetQuery', options, true);

/**
 * Query multiple relationships.
 */
export const compSetQueryInfiniteOptions = (options?: Options<CompSetQueryData>) => {
    const opts = infiniteQueryOptions<CompSetQueryResponse, CompSetQueryError, InfiniteData<CompSetQueryResponse>, QueryKey<Options<CompSetQueryData>>, number | Pick<QueryKey<Options<CompSetQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CompSetQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await compSetQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: compSetQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const compSetActionDownloadQueryKey = (options: Options<CompSetActionDownloadData>) => createQueryKey('compSetActionDownload', options);

/**
 * Download the stored rates file for the hotel competitive set.
 */
export const compSetActionDownloadOptions = (options: Options<CompSetActionDownloadData>) => queryOptions<CompSetActionDownloadResponse, CompSetActionDownloadError, CompSetActionDownloadResponse, ReturnType<typeof compSetActionDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await compSetActionDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: compSetActionDownloadQueryKey(options)
});

export const compSetActionRateQueryQueryKey = (options: Options<CompSetActionRateQueryData>) => createQueryKey('compSetActionRateQuery', options);

/**
 * Get the latest rates for the hotel competitive set
 */
export const compSetActionRateQueryOptions = (options: Options<CompSetActionRateQueryData>) => queryOptions<CompSetActionRateQueryResponse, CompSetActionRateQueryError, CompSetActionRateQueryResponse, ReturnType<typeof compSetActionRateQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await compSetActionRateQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: compSetActionRateQueryQueryKey(options)
});

export const compSetGetHistoryQueryKey = (options: Options<CompSetGetHistoryData>) => createQueryKey('compSetGetHistory', options);

/**
 * return the history for the hotel competitive set
 */
export const compSetGetHistoryOptions = (options: Options<CompSetGetHistoryData>) => queryOptions<CompSetGetHistoryResponse, CompSetGetHistoryError, CompSetGetHistoryResponse, ReturnType<typeof compSetGetHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await compSetGetHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: compSetGetHistoryQueryKey(options)
});

/**
 * Delete a relationship. Return whether a delete occurred.
 */
export const compSetDeleteMutation = (options?: Partial<Options<CompSetDeleteData>>): UseMutationOptions<CompSetDeleteResponse, CompSetDeleteError, Options<CompSetDeleteData>> => {
    const mutationOptions: UseMutationOptions<CompSetDeleteResponse, CompSetDeleteError, Options<CompSetDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await compSetDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const compSetGetQueryKey = (options: Options<CompSetGetData>) => createQueryKey('compSetGet', options);

/**
 * Get the relationship for a given parent, or an empty one if none exists
 */
export const compSetGetOptions = (options: Options<CompSetGetData>) => queryOptions<CompSetGetResponse, CompSetGetError, CompSetGetResponse, ReturnType<typeof compSetGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await compSetGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: compSetGetQueryKey(options)
});

/**
 * Save a relationship, augmenting the existing one
 */
export const compSetPatchMutation = (options?: Partial<Options<CompSetPatchData>>): UseMutationOptions<CompSetPatchResponse, CompSetPatchError, Options<CompSetPatchData>> => {
    const mutationOptions: UseMutationOptions<CompSetPatchResponse, CompSetPatchError, Options<CompSetPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await compSetPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace a relationship, deleting existing children not mentioned
 */
export const compSetPutMutation = (options?: Partial<Options<CompSetPutData>>): UseMutationOptions<CompSetPutResponse, CompSetPutError, Options<CompSetPutData>> => {
    const mutationOptions: UseMutationOptions<CompSetPutResponse, CompSetPutError, Options<CompSetPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await compSetPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companyQueryQueryKey = (options?: Options<CompanyQueryData>) => createQueryKey('companyQuery', options);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const companyQueryOptions = (options?: Options<CompanyQueryData>) => queryOptions<CompanyQueryResponse, CompanyQueryError, CompanyQueryResponse, ReturnType<typeof companyQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companyQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companyQueryQueryKey(options)
});

export const companyQueryInfiniteQueryKey = (options?: Options<CompanyQueryData>): QueryKey<Options<CompanyQueryData>> => createQueryKey('companyQuery', options, true);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const companyQueryInfiniteOptions = (options?: Options<CompanyQueryData>) => {
    const opts = infiniteQueryOptions<CompanyQueryResponse, CompanyQueryError, InfiniteData<CompanyQueryResponse>, QueryKey<Options<CompanyQueryData>>, number | Pick<QueryKey<Options<CompanyQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<CompanyQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await companyQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: companyQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Insert a single noun row.
 */
export const companyInsertMutation = (options?: Partial<Options<CompanyInsertData>>): UseMutationOptions<CompanyInsertResponse, CompanyInsertError, Options<CompanyInsertData>> => {
    const mutationOptions: UseMutationOptions<CompanyInsertResponse, CompanyInsertError, Options<CompanyInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companyInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const companyActionBulkSaveMutation = (options?: Partial<Options<CompanyActionBulkSaveData>>): UseMutationOptions<CompanyActionBulkSaveResponse, CompanyActionBulkSaveError, Options<CompanyActionBulkSaveData>> => {
    const mutationOptions: UseMutationOptions<CompanyActionBulkSaveResponse, CompanyActionBulkSaveError, Options<CompanyActionBulkSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companyActionBulkSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const companyActionSaveMutation = (options?: Partial<Options<CompanyActionSaveData>>): UseMutationOptions<CompanyActionSaveResponse, CompanyActionSaveError, Options<CompanyActionSaveData>> => {
    const mutationOptions: UseMutationOptions<CompanyActionSaveResponse, CompanyActionSaveError, Options<CompanyActionSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companyActionSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companyGetQueryKey = (options: Options<CompanyGetData>) => createQueryKey('companyGet', options);

/**
 * Load a single noun by internal id
 */
export const companyGetOptions = (options: Options<CompanyGetData>) => queryOptions<CompanyGetResponse, CompanyGetError, CompanyGetResponse, ReturnType<typeof companyGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companyGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companyGetQueryKey(options)
});

/**
 * Update a single noun row.
 */
export const companySaveMutation = (options?: Partial<Options<CompanySaveData>>): UseMutationOptions<CompanySaveResponse, CompanySaveError, Options<CompanySaveData>> => {
    const mutationOptions: UseMutationOptions<CompanySaveResponse, CompanySaveError, Options<CompanySaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await companySave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const companyGetChangeLogQueryKey = (options: Options<CompanyGetChangeLogData>) => createQueryKey('companyGetChangeLog', options);

/**
 * Load the change log for a single noun by internal id
 */
export const companyGetChangeLogOptions = (options: Options<CompanyGetChangeLogData>) => queryOptions<CompanyGetChangeLogResponse, CompanyGetChangeLogError, CompanyGetChangeLogResponse, ReturnType<typeof companyGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await companyGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: companyGetChangeLogQueryKey(options)
});

export const contentDownloadQueryKey = (options: Options<ContentDownloadData>) => createQueryKey('contentDownload', options);

/**
 * Download a stored content file
 */
export const contentDownloadOptions = (options: Options<ContentDownloadData>) => queryOptions<ContentDownloadResponse, ContentDownloadError, ContentDownloadResponse, ReturnType<typeof contentDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentDownloadQueryKey(options)
});

export const hotelQueryQueryKey = (options?: Options<HotelQueryData>) => createQueryKey('hotelQuery', options);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const hotelQueryOptions = (options?: Options<HotelQueryData>) => queryOptions<HotelQueryResponse, HotelQueryError, HotelQueryResponse, ReturnType<typeof hotelQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelQueryQueryKey(options)
});

export const hotelQueryInfiniteQueryKey = (options?: Options<HotelQueryData>): QueryKey<Options<HotelQueryData>> => createQueryKey('hotelQuery', options, true);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const hotelQueryInfiniteOptions = (options?: Options<HotelQueryData>) => {
    const opts = infiniteQueryOptions<HotelQueryResponse, HotelQueryError, InfiniteData<HotelQueryResponse>, QueryKey<Options<HotelQueryData>>, number | Pick<QueryKey<Options<HotelQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HotelQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await hotelQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: hotelQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Insert a single noun row.
 */
export const hotelInsertMutation = (options?: Partial<Options<HotelInsertData>>): UseMutationOptions<HotelInsertResponse, HotelInsertError, Options<HotelInsertData>> => {
    const mutationOptions: UseMutationOptions<HotelInsertResponse, HotelInsertError, Options<HotelInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const hotelActionBulkSaveMutation = (options?: Partial<Options<HotelActionBulkSaveData>>): UseMutationOptions<HotelActionBulkSaveResponse, HotelActionBulkSaveError, Options<HotelActionBulkSaveData>> => {
    const mutationOptions: UseMutationOptions<HotelActionBulkSaveResponse, HotelActionBulkSaveError, Options<HotelActionBulkSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionBulkSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const hotelActionSaveMutation = (options?: Partial<Options<HotelActionSaveData>>): UseMutationOptions<HotelActionSaveResponse, HotelActionSaveError, Options<HotelActionSaveData>> => {
    const mutationOptions: UseMutationOptions<HotelActionSaveResponse, HotelActionSaveError, Options<HotelActionSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hotelActionStatusesQueryKey = (options: Options<HotelActionStatusesData>) => createQueryKey('hotelActionStatuses', options);

/**
 * Return the status of multiple hotels, the results are sorted by id
 */
export const hotelActionStatusesOptions = (options: Options<HotelActionStatusesData>) => queryOptions<HotelActionStatusesResponse, HotelActionStatusesError, HotelActionStatusesResponse, ReturnType<typeof hotelActionStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelActionStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelActionStatusesQueryKey(options)
});

export const hotelActionExcelRateChartQueryKey = (options: Options<HotelActionExcelRateChartData>) => createQueryKey('hotelActionExcelRateChart', options);

/**
 * Download the latest rate chart for a hotel.
 */
export const hotelActionExcelRateChartOptions = (options: Options<HotelActionExcelRateChartData>) => queryOptions<HotelActionExcelRateChartResponse, HotelActionExcelRateChartError, HotelActionExcelRateChartResponse, ReturnType<typeof hotelActionExcelRateChartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelActionExcelRateChart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelActionExcelRateChartQueryKey(options)
});

export const hotelActionGsheetsRateChartQueryKey = (options: Options<HotelActionGsheetsRateChartData>) => createQueryKey('hotelActionGsheetsRateChart', options);

/**
 * The URI of a gsheet chart for a hotel
 */
export const hotelActionGsheetsRateChartOptions = (options: Options<HotelActionGsheetsRateChartData>) => queryOptions<HotelActionGsheetsRateChartResponse, HotelActionGsheetsRateChartError, HotelActionGsheetsRateChartResponse, ReturnType<typeof hotelActionGsheetsRateChartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelActionGsheetsRateChart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelActionGsheetsRateChartQueryKey(options)
});

export const hotelGetQueryKey = (options: Options<HotelGetData>) => createQueryKey('hotelGet', options);

/**
 * Load a single noun by internal id
 */
export const hotelGetOptions = (options: Options<HotelGetData>) => queryOptions<HotelGetResponse, HotelGetError, HotelGetResponse, ReturnType<typeof hotelGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelGetQueryKey(options)
});

/**
 * Update a single noun row.
 */
export const hotelSaveMutation = (options?: Partial<Options<HotelSaveData>>): UseMutationOptions<HotelSaveResponse, HotelSaveError, Options<HotelSaveData>> => {
    const mutationOptions: UseMutationOptions<HotelSaveResponse, HotelSaveError, Options<HotelSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const hotelGetChangeLogQueryKey = (options: Options<HotelGetChangeLogData>) => createQueryKey('hotelGetChangeLog', options);

/**
 * Load the change log for a single noun by internal id
 */
export const hotelGetChangeLogOptions = (options: Options<HotelGetChangeLogData>) => queryOptions<HotelGetChangeLogResponse, HotelGetChangeLogError, HotelGetChangeLogResponse, ReturnType<typeof hotelGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelGetChangeLogQueryKey(options)
});

export const locationQueryQueryKey = (options?: Options<LocationQueryData>) => createQueryKey('locationQuery', options);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const locationQueryOptions = (options?: Options<LocationQueryData>) => queryOptions<LocationQueryResponse, LocationQueryError, LocationQueryResponse, ReturnType<typeof locationQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await locationQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: locationQueryQueryKey(options)
});

export const locationQueryInfiniteQueryKey = (options?: Options<LocationQueryData>): QueryKey<Options<LocationQueryData>> => createQueryKey('locationQuery', options, true);

/**
 * Query multiple noun rows using the noun-specific request parameters.
 */
export const locationQueryInfiniteOptions = (options?: Options<LocationQueryData>) => {
    const opts = infiniteQueryOptions<LocationQueryResponse, LocationQueryError, InfiniteData<LocationQueryResponse>, QueryKey<Options<LocationQueryData>>, number | Pick<QueryKey<Options<LocationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<LocationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await locationQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: locationQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Insert a single noun row.
 */
export const locationInsertMutation = (options?: Partial<Options<LocationInsertData>>): UseMutationOptions<LocationInsertResponse, LocationInsertError, Options<LocationInsertData>> => {
    const mutationOptions: UseMutationOptions<LocationInsertResponse, LocationInsertError, Options<LocationInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await locationInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk-save multiple noun rows. Each noun has one or more identifiers in order to 'upsert' an existing document, starting with its id. See the noun's schema documentation.
 */
export const locationActionBulkSaveMutation = (options?: Partial<Options<LocationActionBulkSaveData>>): UseMutationOptions<LocationActionBulkSaveResponse, LocationActionBulkSaveError, Options<LocationActionBulkSaveData>> => {
    const mutationOptions: UseMutationOptions<LocationActionBulkSaveResponse, LocationActionBulkSaveError, Options<LocationActionBulkSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await locationActionBulkSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save one noun by natural identifer. Each noun has one or more identifiers in order to 'upsert' an existing document. See the noun's schema documentation.
 */
export const locationActionSaveMutation = (options?: Partial<Options<LocationActionSaveData>>): UseMutationOptions<LocationActionSaveResponse, LocationActionSaveError, Options<LocationActionSaveData>> => {
    const mutationOptions: UseMutationOptions<LocationActionSaveResponse, LocationActionSaveError, Options<LocationActionSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await locationActionSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationGetQueryKey = (options: Options<LocationGetData>) => createQueryKey('locationGet', options);

/**
 * Load a single noun by internal id
 */
export const locationGetOptions = (options: Options<LocationGetData>) => queryOptions<LocationGetResponse, LocationGetError, LocationGetResponse, ReturnType<typeof locationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await locationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: locationGetQueryKey(options)
});

/**
 * Update a single noun row.
 */
export const locationSaveMutation = (options?: Partial<Options<LocationSaveData>>): UseMutationOptions<LocationSaveResponse, LocationSaveError, Options<LocationSaveData>> => {
    const mutationOptions: UseMutationOptions<LocationSaveResponse, LocationSaveError, Options<LocationSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await locationSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const locationGetChangeLogQueryKey = (options: Options<LocationGetChangeLogData>) => createQueryKey('locationGetChangeLog', options);

/**
 * Load the change log for a single noun by internal id
 */
export const locationGetChangeLogOptions = (options: Options<LocationGetChangeLogData>) => queryOptions<LocationGetChangeLogResponse, LocationGetChangeLogError, LocationGetChangeLogResponse, ReturnType<typeof locationGetChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await locationGetChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: locationGetChangeLogQueryKey(options)
});

export const organizationUserQueryQueryKey = (options?: Options<OrganizationUserQueryData>) => createQueryKey('organizationUserQuery', options);

/**
 * Query multiple relationships.
 */
export const organizationUserQueryOptions = (options?: Options<OrganizationUserQueryData>) => queryOptions<OrganizationUserQueryResponse, OrganizationUserQueryError, OrganizationUserQueryResponse, ReturnType<typeof organizationUserQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationUserQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationUserQueryQueryKey(options)
});

export const organizationUserQueryInfiniteQueryKey = (options?: Options<OrganizationUserQueryData>): QueryKey<Options<OrganizationUserQueryData>> => createQueryKey('organizationUserQuery', options, true);

/**
 * Query multiple relationships.
 */
export const organizationUserQueryInfiniteOptions = (options?: Options<OrganizationUserQueryData>) => {
    const opts = infiniteQueryOptions<OrganizationUserQueryResponse, OrganizationUserQueryError, InfiniteData<OrganizationUserQueryResponse>, QueryKey<Options<OrganizationUserQueryData>>, number | Pick<QueryKey<Options<OrganizationUserQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<OrganizationUserQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await organizationUserQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: organizationUserQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const organizationUserGetQueryKey = (options: Options<OrganizationUserGetData>) => createQueryKey('organizationUserGet', options);

/**
 * Get the relationship for a given parent, or an empty one if none exists
 */
export const organizationUserGetOptions = (options: Options<OrganizationUserGetData>) => queryOptions<OrganizationUserGetResponse, OrganizationUserGetError, OrganizationUserGetResponse, ReturnType<typeof organizationUserGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationUserGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationUserGetQueryKey(options)
});

/**
 * Save a relationship, augmenting the existing one
 */
export const organizationUserPatchMutation = (options?: Partial<Options<OrganizationUserPatchData>>): UseMutationOptions<OrganizationUserPatchResponse, OrganizationUserPatchError, Options<OrganizationUserPatchData>> => {
    const mutationOptions: UseMutationOptions<OrganizationUserPatchResponse, OrganizationUserPatchError, Options<OrganizationUserPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationUserPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace a relationship, deleting existing children not mentioned
 */
export const organizationUserPutMutation = (options?: Partial<Options<OrganizationUserPutData>>): UseMutationOptions<OrganizationUserPutResponse, OrganizationUserPutError, Options<OrganizationUserPutData>> => {
    const mutationOptions: UseMutationOptions<OrganizationUserPutResponse, OrganizationUserPutError, Options<OrganizationUserPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationUserPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload a logo file.
 */
export const organizationActionUploadLogoMutation = (options?: Partial<Options<OrganizationActionUploadLogoData>>): UseMutationOptions<OrganizationActionUploadLogoResponse, OrganizationActionUploadLogoError, Options<OrganizationActionUploadLogoData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionUploadLogoResponse, OrganizationActionUploadLogoError, Options<OrganizationActionUploadLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionUploadLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const organizationGetQueryKey = (options?: Options<OrganizationGetData>) => createQueryKey('organizationGet', options);

/**
 * Get the current organization information
 */
export const organizationGetOptions = (options?: Options<OrganizationGetData>) => queryOptions<OrganizationGetResponse, OrganizationGetError, OrganizationGetResponse, ReturnType<typeof organizationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await organizationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: organizationGetQueryKey(options)
});

/**
 * Save the current organization information
 */
export const organizationSaveMutation = (options?: Partial<Options<OrganizationSaveData>>): UseMutationOptions<OrganizationSaveResponse, OrganizationSaveError, Options<OrganizationSaveData>> => {
    const mutationOptions: UseMutationOptions<OrganizationSaveResponse, OrganizationSaveError, Options<OrganizationSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check if the given scopes are allowed for the current session
 */
export const organizationActionAllowedScopesMutation = (options?: Partial<Options<OrganizationActionAllowedScopesData>>): UseMutationOptions<OrganizationActionAllowedScopesResponse, OrganizationActionAllowedScopesError, Options<OrganizationActionAllowedScopesData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionAllowedScopesResponse, OrganizationActionAllowedScopesError, Options<OrganizationActionAllowedScopesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionAllowedScopes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * The URI for the organization-specific google drive folder
 */
export const organizationActionGsheetsFolderMutation = (options?: Partial<Options<OrganizationActionGsheetsFolderData>>): UseMutationOptions<OrganizationActionGsheetsFolderResponse, OrganizationActionGsheetsFolderError, Options<OrganizationActionGsheetsFolderData>> => {
    const mutationOptions: UseMutationOptions<OrganizationActionGsheetsFolderResponse, OrganizationActionGsheetsFolderError, Options<OrganizationActionGsheetsFolderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await organizationActionGsheetsFolder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rateHistoryQueryRatesQueryKey = (options: Options<RateHistoryQueryRatesData>) => createQueryKey('rateHistoryQueryRates', options);

/**
 * Query rate history for the given hotel and date range
 */
export const rateHistoryQueryRatesOptions = (options: Options<RateHistoryQueryRatesData>) => queryOptions<RateHistoryQueryRatesResponse, RateHistoryQueryRatesError, RateHistoryQueryRatesResponse, ReturnType<typeof rateHistoryQueryRatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateHistoryQueryRates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateHistoryQueryRatesQueryKey(options)
});

export const rateHistoryQueryRatesInfiniteQueryKey = (options: Options<RateHistoryQueryRatesData>): QueryKey<Options<RateHistoryQueryRatesData>> => createQueryKey('rateHistoryQueryRates', options, true);

/**
 * Query rate history for the given hotel and date range
 */
export const rateHistoryQueryRatesInfiniteOptions = (options: Options<RateHistoryQueryRatesData>) => {
    const opts = infiniteQueryOptions<RateHistoryQueryRatesResponse, RateHistoryQueryRatesError, InfiniteData<RateHistoryQueryRatesResponse>, QueryKey<Options<RateHistoryQueryRatesData>>, number | Pick<QueryKey<Options<RateHistoryQueryRatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RateHistoryQueryRatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await rateHistoryQueryRates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rateHistoryQueryRatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const rateLatestQueryLatestQueryKey = (options: Options<RateLatestQueryLatestData>) => createQueryKey('rateLatestQueryLatest', options);

/**
 * Query latest rate rows for the given hotel and date range
 */
export const rateLatestQueryLatestOptions = (options: Options<RateLatestQueryLatestData>) => queryOptions<RateLatestQueryLatestResponse, RateLatestQueryLatestError, RateLatestQueryLatestResponse, ReturnType<typeof rateLatestQueryLatestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateLatestQueryLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateLatestQueryLatestQueryKey(options)
});

export const rateLatestQueryLatestInfiniteQueryKey = (options: Options<RateLatestQueryLatestData>): QueryKey<Options<RateLatestQueryLatestData>> => createQueryKey('rateLatestQueryLatest', options, true);

/**
 * Query latest rate rows for the given hotel and date range
 */
export const rateLatestQueryLatestInfiniteOptions = (options: Options<RateLatestQueryLatestData>) => {
    const opts = infiniteQueryOptions<RateLatestQueryLatestResponse, RateLatestQueryLatestError, InfiniteData<RateLatestQueryLatestResponse>, QueryKey<Options<RateLatestQueryLatestData>>, number | Pick<QueryKey<Options<RateLatestQueryLatestData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<RateLatestQueryLatestData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await rateLatestQueryLatest({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: rateLatestQueryLatestInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const rateStayQueryQueryKey = (options: Options<RateStayQueryData>) => createQueryKey('rateStayQuery', options);

/**
 * Query multiple rate rows for the given day range by hotel or city.
 */
export const rateStayQueryOptions = (options: Options<RateStayQueryData>) => queryOptions<RateStayQueryResponse, RateStayQueryError, RateStayQueryResponse, ReturnType<typeof rateStayQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await rateStayQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: rateStayQueryQueryKey(options)
});

export const userInvitationQueryQueryKey = (options?: Options<UserInvitationQueryData>) => createQueryKey('userInvitationQuery', options);

/**
 * Query the invitations.
 */
export const userInvitationQueryOptions = (options?: Options<UserInvitationQueryData>) => queryOptions<UserInvitationQueryResponse, UserInvitationQueryError, UserInvitationQueryResponse, ReturnType<typeof userInvitationQueryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userInvitationQuery({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userInvitationQueryQueryKey(options)
});

export const userInvitationQueryInfiniteQueryKey = (options?: Options<UserInvitationQueryData>): QueryKey<Options<UserInvitationQueryData>> => createQueryKey('userInvitationQuery', options, true);

/**
 * Query the invitations.
 */
export const userInvitationQueryInfiniteOptions = (options?: Options<UserInvitationQueryData>) => {
    const opts = infiniteQueryOptions<UserInvitationQueryResponse, UserInvitationQueryError, InfiniteData<UserInvitationQueryResponse>, QueryKey<Options<UserInvitationQueryData>>, number | Pick<QueryKey<Options<UserInvitationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<UserInvitationQueryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await userInvitationQuery({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: userInvitationQueryInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Insert an invitation.
 */
export const userInvitationInsertMutation = (options?: Partial<Options<UserInvitationInsertData>>): UseMutationOptions<UserInvitationInsertResponse, UserInvitationInsertError, Options<UserInvitationInsertData>> => {
    const mutationOptions: UseMutationOptions<UserInvitationInsertResponse, UserInvitationInsertError, Options<UserInvitationInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userInvitationInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete the invitation by id.
 */
export const userInvitationDeleteMutation = (options?: Partial<Options<UserInvitationDeleteData>>): UseMutationOptions<UserInvitationDeleteResponse, UserInvitationDeleteError, Options<UserInvitationDeleteData>> => {
    const mutationOptions: UseMutationOptions<UserInvitationDeleteResponse, UserInvitationDeleteError, Options<UserInvitationDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userInvitationDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Leave the given organization
 */
export const userActionLeaveOrganizationMutation = (options?: Partial<Options<UserActionLeaveOrganizationData>>): UseMutationOptions<UserActionLeaveOrganizationResponse, UserActionLeaveOrganizationError, Options<UserActionLeaveOrganizationData>> => {
    const mutationOptions: UseMutationOptions<UserActionLeaveOrganizationResponse, UserActionLeaveOrganizationError, Options<UserActionLeaveOrganizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userActionLeaveOrganization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userGetCurrentUserQueryKey = (options?: Options<UserGetCurrentUserData>) => createQueryKey('userGetCurrentUser', options);

/**
 * Get the current user's information
 */
export const userGetCurrentUserOptions = (options?: Options<UserGetCurrentUserData>) => queryOptions<UserGetCurrentUserResponse, UserGetCurrentUserError, UserGetCurrentUserResponse, ReturnType<typeof userGetCurrentUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetCurrentUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetCurrentUserQueryKey(options)
});

/**
 * Save the current user's information
 */
export const userSaveCurrentUserMutation = (options?: Partial<Options<UserSaveCurrentUserData>>): UseMutationOptions<UserSaveCurrentUserResponse, UserSaveCurrentUserError, Options<UserSaveCurrentUserData>> => {
    const mutationOptions: UseMutationOptions<UserSaveCurrentUserResponse, UserSaveCurrentUserError, Options<UserSaveCurrentUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userSaveCurrentUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const userGetOrganizationsQueryKey = (options?: Options<UserGetOrganizationsData>) => createQueryKey('userGetOrganizations', options);

/**
 * My organizations
 */
export const userGetOrganizationsOptions = (options?: Options<UserGetOrganizationsData>) => queryOptions<UserGetOrganizationsResponse, UserGetOrganizationsError, UserGetOrganizationsResponse, ReturnType<typeof userGetOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await userGetOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: userGetOrganizationsQueryKey(options)
});
